import { formatDate, formatName } from '../../common';
import { get, keyBy, map, mapValues, uniq } from 'lodash';

export const createAthleteRecord = entry => ({
  uuid: entry.uuid,
  lotNumber: get(entry, 'lotNumber'),
  sex: get(entry.gender, 'letter'),
  name: formatName(entry),
  teams: map(entry.teams, 'abbreviation'),
  ageGroups: uniq(map(entry.contests, 'ageGroup.abbreviation')),
  // TODO: Rename these to bodyweightCategory!
  category: get(entry.contest, 'bodyweightCategory.abbreviation'),
  categories: uniq(map(entry.contests, 'bodyweightCategory.abbreviation')),
  contests: uniq(map(entry.contests, 'title')),
  group: get(entry.group, 'letter'),
  dateOfBirth: formatDate(entry.dateOfBirth, { width: 'fixed' }),
  entryTotal: entry.total || (entry.totalMinimum && `(${entry.totalMinimum})`),
  bodyweight: get(entry.weighInDatum, 'bodyweight'),
  weighInDeclarationsByLiftId: mapValues(
    keyBy(entry.weighInDeclarations, 'lift'),
    'weight',
  ),
});



// WEBPACK FOOTER //
// ./src/pages/Home/common.js